import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ControlContainer, FormGroup, FormControl } from '@angular/forms';
import { DatePipe } from '@angular/common';

import { FromPicklistPipe } from 'src/app/shared/pipes/fromPicklistPipe.pipe';
import { ToPicklistPipe } from 'src/app/shared/pipes/toPicklistPipe.pipe';

import { SharingDataService } from 'src/app/Services/sharing-data.service';
import { GridTableParametersService } from 'src/app/template/gridTemplate/gridTableParameters.service';

@Component({
  selector: 'formly2',
  templateUrl: './formly2.component.html',
  styleUrls: ['./formly2.component.css']
})
export class Formly2Component implements OnInit {

  @Input() public formGroupBuilderInput;
  @Input() public formConfigObjectInput;
  @Output() public actionOutput = new EventEmitter();
  
  constructor(
    private parentFormControl: ControlContainer,
    private shareData: SharingDataService,
    public fromPicklist: FromPicklistPipe,
    public toPicklist: ToPicklistPipe,
    public grid: GridTableParametersService,
    public datepipe: DatePipe,
    ) { }

  Picklist = {
    kapadu: [{key:11,text:"ka"},{key:22,text:"pa"},{key:33,text:"du"}],
    matafu: [{key:11,text:"ma"},{key:22,text:"ta"},{key:33,text:"fu"}],
  };
  
  ngOnInit(): void {
  }

  onSubmit(action : string) {
    this.actionOutput.emit(action)
  }

}
